var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.773 3.96972C10.6324 3.82911 10.4416 3.75012 10.2427 3.75012C10.0439 3.75012 9.85314 3.82911 9.7125 3.96972L5.99999 7.68221L2.2875 3.96971C2.14604 3.8331 1.95659 3.7575 1.75994 3.75921C1.5633 3.76092 1.37519 3.83979 1.23613 3.97885C1.09707 4.11791 1.0182 4.30602 1.01649 4.50266C1.01478 4.69931 1.09038 4.88876 1.22699 5.03021L5.46975 9.27296C5.61039 9.41357 5.80112 9.49255 5.99999 9.49255C6.19887 9.49255 6.3896 9.41357 6.53024 9.27296L10.773 5.03021C10.9136 4.88957 10.9926 4.69884 10.9926 4.49996C10.9926 4.30109 10.9136 4.11036 10.773 3.96972Z",
    fill: "#CBCDCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpen);
export default __webpack_public_path__ + "static/media/arrow-open.52f353d59a69f9dc4d00ea6bec85df44.svg";
export { ForwardRef as ReactComponent };